<template>
  <!--Adding Props to Make Component More usable-->
  <div>
    <b-container style="padding-bottom:25px">
      <!--hide title if parent reqires it-->
      <b-row v-if="fieldsOnly !== true" :no-gutters="true">
        <b-col cols="12">
          <p style="font-weight:bold">Add New Phone</p>
        </b-col>
      </b-row>
      <b-row :no-gutters="true">
        <b-col cols="12">
          <b-form-group
            id="phone-1"
            label="Phone"
            label-for="input-1"
            :invalid-feedback="invalidFeedbackPhoneNumber"
            :valid-feedback="validFeedbackPhoneNumber"
            :state="statePhoneNumber"
          >
            <b-form-input
              id="phone-input-1"
              autocomplete="off"
              v-model="phone"
              :state="statePhoneNumber"
              placeholder="Add a phone number"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row :no-gutters="true">
        <b-col cols="12">
          <b-form-group
            id="phoneType-1"
            label="Phone Type"
            label-for="phone-type-input-2"
            :invalid-feedback="invalidFeedbackPhoneNumberType"
            :valid-feedback="validFeedbackPhoneNumberType"
            :state="statePhoneNumberType"
          >
            <b-form-select
              id="input-1"
              autocomplete="off"
              v-model="numberType"
              :options="options"
              :state="statePhoneNumberType"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <!--hide buttons if parent reqires it-->

      <b-row align-v="start" align-h="end">
        <b-col cols="8"> </b-col>

        <b-col cols="2">
          <b-button
            v-if="fieldsOnly !== true"
            style="float:right"
            @click="
              $store.dispatch('showHideElement', {
                elementName: 'phoneAddForm',
                elementValue: false,
              })
            "
            >Cancel</b-button
          >
        </b-col>

        <b-col
          v-if="
            fieldsOnly !== true &&
              statePhoneNumber == true &&
              statePhoneNumberType == true
          "
          cols="2"
        >
          <b-button @click="addPhone()" variant="primary" style="float:right"
            >OK</b-button
          >
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["phoneNumber", "phoneNumberType", "fieldsOnly"],

  computed: {
    statePhoneNumber() {
      if (this.phone == null) {
        return null;
      } else if (this.phone.length < 11) {
        this.$emit("changePhoneNo", null);
        return false;
      }
      this.$emit("changePhoneNo", this.phone);
      return true;
    },
    statePhoneNumberType() {
      if (this.numberType == null) {
        return null;
      } else if (this.numberType.length < 1) {
        this.$emit("changeNumberType", null);
        return false;
      }
      this.$emit("changeNumberType", this.numberType);
      return true;
    },
    urlPrefix() {
      return this.$store.getters.urlPrefix;
    },
  },
  data() {
    return {
      phone: this.PhoneNo,
      invalidFeedbackPhoneNumber: "Type a valid phone number",
      validFeedbackPhoneNumber: "Thanks !",
      numberType: this.phoneNumberType,
      invalidFeedbackPhoneNumberType: "Type a valid phone number",
      validFeedbackPhoneNumberType: "Thanks !",
      options: [
        { value: null, text: "Please choose a type of phone" },
        { value: "Landline", text: "Landline" },
        { value: "Mobile", text: "Mobile" },
      ],
    };
  },
  methods: {
    addPhone() {
      const payload = {};
      payload.url = this.urlPrefix + "api/phone/";
      payload.mutationName = "phoneUpdate";
      payload.data = {
        person: this.$store.getters.person.id,
        phoneNumber: this.phone,
        numberType: this.numberType,
      };
      this.$store.dispatch("genericPostApiCall", payload);
      this.$store.dispatch("showHideElement", {
        elementName: "phoneAddForm",
        elementValue: false,
      });
    },
  },
};
</script>

<style></style>
